import { Colors } from "../../consts/Colors";
import FONTS from "../../consts/Fonts";

export default class InputText extends Phaser.GameObjects.Container {
    constructor(scene, x, y, {placeholder, width, height}) {
        super(scene, x, y, []);

        this.scene = scene;
        scene.add.existing(this);

        this.locked = false

        this.updateFunction = () => {};
        this.closeFunction = () => {};

        let fondInput = this.scene.add.rexRoundRectangle(0, 0, width, height, 8, Colors.Elmt.White).setOrigin(0.5);
        fondInput.setStrokeStyle(2, Colors.Elmt.Grey)
        this.add(fondInput)

        this.placeholderText = this.scene.add.text(fondInput.x - fondInput.width/2 + 20, 0, placeholder, {
            fontSize: "18px",
            fontFamily: FONTS.InterRegular,
            color: Colors.Text.DarkGrey,
            fixedWidth: fondInput.width - 80,
            valign: "center"
        }).setOrigin(0, 0.5)
        this.add(this.placeholderText)


        this.inputText = this.scene.add.text(fondInput.x - fondInput.width/2 + 20, 0, "", {
            fontSize: "18px",
            fontFamily: FONTS.InterRegular,
            color: Colors.Text.DarkGrey,
            fixedWidth: fondInput.width - 80,
            valign: "center"
        }).setOrigin(0, 0.5)
        this.add(this.inputText)


        var editor = this.scene.plugins.get('rexTextEditPlugin').add(this.inputText, {
            type: 'text',
            onOpen: (textObject) => {
                if(this.locked) return;
            },
            onTextChanged: (textObject, text) => {
                if(this.locked) return;
                textObject.text =  text;
                this.updateFunction(this, text);

                if(text.length > 0){
                    this.iconClose.setAlpha(1)
                    this.placeholderText.setAlpha(0)
                }else{
                    this.iconClose.setAlpha(0)
                    this.placeholderText.setAlpha(1)
                    this.inputText.text = "";
                }
            },
            onClose: (textObject) => {
                if(this.locked) return;
                this.closeFunction(this, textObject.text);
                if(textObject.text.length == 0){
                    this.iconClose.setAlpha(0)
                    this.placeholderText.setAlpha(1)
                    this.inputText.text = "";
                }
            },
            selectAll: true,
            enterClose: true,
            other_styles: {
                'font-weight': 'bold',
                'text-align': 'center',
            }
        });

        this.iconClose = this.scene.add.image(fondInput.width/2 - 32, 0, 'icon_close')
            .setOrigin(0.5)
            .setInteractive({useHandCursor: true});
        this.add(this.iconClose)
        this.iconClose.setAlpha(0)
        this.iconClose.on('pointerup', () => {
            this.inputText.text = "";
            this.placeholderText.setAlpha(1)
            this.iconClose.setAlpha(0)
            this.updateFunction(this, "");

        })

        this.setSize(fondInput.width, fondInput.height);
    }

    getInputTextValue(){
        return this.inputText.text;
    }

    setInputTextValue(text){
        this.inputText.text = text;
        if(text.length > 0){
            this.iconClose.setAlpha(1)
            this.placeholderText.setAlpha(0)
        }else{
            this.iconClose.setAlpha(0)
            this.placeholderText.setAlpha(1)
            this.inputText.text = "";
        }
    }

    setOnUpdateFunction(updateFunction){
        this.updateFunction = (elmt, text) => {updateFunction(elmt, text)};
    }

    setOnCloseFunction(closeFunction){
        this.closeFunction = (elmt, text) => {closeFunction(elmt, text)};
    }

    setLocked(){
        this.locked = true;
        this.iconClose.disableInteractive();
        this.inputText.disableInteractive();
    }

    setUnlocked(){
        this.locked = false;
        this.iconClose.setInteractive({useHandCursor: true});
        this.inputText.setInteractive();
    }

}